import TemplateFlex from 'typescript-styled-flex'
import is from 'typescript-styled-is'
import styled from '../../../../theme'

const Flex:any = styled(TemplateFlex as any)<{ print?: boolean }>`
  display: none;

  @media (min-width: ${props => props.theme.breakpoints.tablet}) {
    display: flex;
  }

  ${is('print')`
  	display: flex;
  `};
`

export default Flex as any
